<template>
  <div>
    <h2>旧配额统计（历史口径）</h2>
    <el-alert title="此页用旧客户配额折算供应，并按水质结果字段计次，不能证明实际购买或外购。请使用“实物库存与用量核验”开展新核验。" type="warning" :closable="false" style="margin-bottom:16px" />

    <el-row :gutter="20" class="search-bar">
      <el-col :span="6">
        <el-input v-model="search.accountKeyword" placeholder="账户名称/编号" clearable @keyup.enter="doSearch" />
      </el-col>
      <el-col :span="4">
        <el-select v-model="search.reagentTypeId" placeholder="试剂类型" clearable style="width:100%;">
          <el-option v-for="item in reagentTypeList" :key="item.id" :label="item.reagentName" :value="item.id" />
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-input v-model="search.startMonth" placeholder="开始月份" clearable />
      </el-col>
      <el-col :span="3">
        <el-input v-model="search.endMonth" placeholder="结束月份" clearable />
      </el-col>
      <el-col :span="3">
        <el-select v-model="search.riskLevel" placeholder="风险等级" clearable style="width:100%;">
          <el-option label="正常" value="NORMAL" />
          <el-option label="注意" value="MEDIUM" />
          <el-option label="警告" value="HIGH" />
        </el-select>
      </el-col>
      <el-col :span="5">
        <el-button type="primary" @click="doSearch">查询</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-col>
    </el-row>

    <el-table :data="tableData" border style="width:100%;" v-loading="loading">
      <el-table-column prop="accountName" label="账户名称" min-width="120" />
      <el-table-column prop="bindDeviceCount" label="绑定设备数" width="100" align="center" />
      <el-table-column prop="sharedDeviceCount" label="共享设备数" width="100" align="center" />
      <el-table-column prop="reagentName" label="试剂名称" min-width="120" />
      <el-table-column prop="purchaseBottleCount" label="旧配额折算(瓶)" width="125" align="center" />
      <el-table-column prop="theoryTestTimes" label="理论检测次数" width="110" align="center" />
      <el-table-column prop="actualTestTimes" label="实际检测次数" width="110" align="center" />
      <el-table-column label="使用率" width="90" align="center">
        <template v-slot="scope">
          <span :style="{ color: getUsageRateColor(scope.row.usageRate) }">
            {{ scope.row.usageRate != null ? scope.row.usageRate + '%' : '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="风险等级" width="90" align="center">
        <template v-slot="scope">
          <el-tag :type="getRiskTagType(scope.row.riskLevel)" size="small">{{ scope.row.riskText }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template v-slot="scope">
          <el-button type="text" size="small" @click="viewDetail(scope.row)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
     <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
       :current-page="page.current" :page-size="page.pageSize" :total="page.total"
       :page-sizes="[20, 50, 100]" layout="total, sizes, prev, pager, next, jumper" />
    </div>
  </div>
</template>

<script>
import { fetchAccountMonitorPage, fetchReagentTypeList } from "@/api/reagentMonitor";

export default {
  data() {
    return {
      search: { accountKeyword: "", reagentTypeId: null, startMonth: "", endMonth: "", riskLevel: "" },
      tableData: [],
     page: { current: 1, pageSize: 20, total: 0 },
      loading: false,
      reagentTypeList: [],
    };
  },
  created() {
    this.loadReagentTypes();
    this.doSearch();
  },
  methods: {
    async loadReagentTypes() {
      try {
        const res = await fetchReagentTypeList();
        if (res.code === 200) {
          this.reagentTypeList = res.data || [];
        }
      } catch (e) { console.error(e); }
    },
    async doSearch() {
      this.loading = true;
      try {
        const res = await fetchAccountMonitorPage({
          accountKeyword: this.search.accountKeyword || undefined,
          reagentTypeId: this.search.reagentTypeId || undefined,
          startMonth: this.search.startMonth || undefined,
          endMonth: this.search.endMonth || undefined,
          riskLevel: this.search.riskLevel || undefined,
          current: this.page.current,
          pageSize: this.page.pageSize,
        });
        if (res.code === 200) {
          this.tableData = res.data.records || [];
          this.page.total = res.data.total || 0;
        }
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    },
    resetSearch() {
      this.search = { accountKeyword: "", reagentTypeId: null, startMonth: "", endMonth: "", riskLevel: "" };
      this.page.current = 1;
      this.doSearch();
    },
    viewDetail(row) {
      this.$router.push({ path: `/reagent-monitor/account/detail/${row.accountId}` });
    },
    handleSizeChange(size) {
      this.page.pageSize = size;
      this.page.current = 1;
      this.doSearch();
    },
    handleCurrentChange(page) {
      this.page.current = page;
      this.doSearch();
    },
    getUsageRateColor(rate) {
      if (rate == null) return "#909399";
      if (rate >= 100) return "#F56C6C";
      if (rate >= 50) return "#E6A23C";
      return "#67C23A";
    },
    getRiskTagType(level) {
      if (level === "HIGH") return "danger";
      if (level === "MEDIUM") return "warning";
      return "success";
    },
  },
};
</script>

<style scoped>
.search-bar { margin-bottom: 16px; }
.pagination { margin-top: 16px; display: flex; justify-content: flex-end; }
</style>
